import { ResetPasswordRecoveryPasswordInitNamespace } from '@core/models/client';

export namespace ResetPasswordRecoveryPasswordInitApiNamespace {
  export class IN {
    username: string = '';
    captchaToken: string = '';
    constructor(input: ResetPasswordRecoveryPasswordInitNamespace.IN) {
      this.username = input.login;
      this.captchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    // recoverPasswordKey: string = '';
  }
}
